export default ['$scope', 'wbConfig', 'locale', 'toggle', function($scope, wbConfig, locale, toggle) {
  this.config = wbConfig;

  toggle.register($scope);

  const frenchDebtTypes = {
    1: 'Hypothèque',
    2: 'Prêt/crédit',
    3: 'Autre dette',
  };

  const frenchAssetTypes = {
    1: 'REER',
    2: 'CELI',
    3: 'Autre Compte',
    4: 'Immobilier',
    5: 'Autre Actif',
    6: 'REEE',
  };

  this.addAsset = (type = null, name) => {
    this.setFormDirty();
    const results = this.assets.push({
      type,
      typeName: name,
      name: locale.isFrench() ? `Mon ${frenchAssetTypes[type]}` : `My ${name}`,
      balance: 0,
      payment: 0,
      paymentFrequency: 12,
    });
    toggle.toggle($scope);
    return results;
  };

  this.addDebt = (type = null, name) => {
    this.setFormDirty();
    const results = this.debts.push({
      type,
      typeName: name,
      name: locale.isFrench() ? `Mon ${frenchDebtTypes[type]}` : `My ${name}`,
      balance: 0,
      payment: 0,
      paymentFrequency: 12,
      interestRate: 0.04,
    });
    toggle.toggle($scope);
    return results;
  };

  this.removeAsset = (index) => {
    this.setFormDirty();
    return _.pullAt(this.assets, index);
  };

  this.removeDebt = (index) => {
    this.setFormDirty();
    return _.pullAt(this.debts, index);
  };

  this.netWorth = () => _.sumBy(this.assets, 'balance') - _.sumBy(this.debts, 'balance');

  this.setFormDirty = () => {
    $scope.ctrl.setDirty();
  };

  $scope.$watch('ctrl.clientProfile', clientProfile => {
    if (clientProfile == null) { return; }
    if (!this.clientProfile.assets) { this.clientProfile.assets = []; }
    if (!this.clientProfile.debts) { this.clientProfile.debts = []; }
    this.assets = clientProfile.assets;
    this.debts = clientProfile.debts;
  });

  return this;
}];
